(function initProductInfoBlock() {
  if (window.__productInfoBlockInitialized) return;
  window.__productInfoBlockInitialized = true;

  function openInfoBlockModal(trigger) {
    const modal = document.getElementById(trigger.dataset.modalId);
    if (!modal || !window.basicLightbox) return;

    const content = document.createElement('div');
    const clone = modal.cloneNode(true);
    clone.classList.remove('hide');
    clone.removeAttribute('aria-hidden');
    content.appendChild(clone);

    const instance = window.basicLightbox.create(content, {
      closable: true,
      className: 'basicLightbox--product-info-block'
    });

    instance.show();
  }

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('[data-js-info-block-trigger]');
      if (!trigger) return;

      event.preventDefault();
      openInfoBlockModal(trigger);
    },
    true
  );
})();
